import apiService from 'services/api'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import { dealsPipelineFilterStore } from 'components/Filters/FilterStore'
import FilterModal, {
  FilterGroup,
} from 'components/Filters/components/FilterModal'
import { useCategorySubcategoryOptions } from 'hooks/useCategorySubcategoryFilterOptions'
import { RangeFilter } from '../../Filters/fields/RangeFilter'
import { DateRangeFilter } from '../../Filters/fields/DateRangeFilter'

export default function DealsPipelineTableFilters() {
  const api = apiService()
  const { data: userOptions } = api.useGetUserOptions()
  const { data: stageOptions } = api.useGetSalesStageOptions()
  const { data: products } = api.useGetProductsOptions()
  const { categoriesOptions, subCategoriesOptions } =
    useCategorySubcategoryOptions({
      filterStore: dealsPipelineFilterStore,
    })

  return (
    <FilterModal
      store={dealsPipelineFilterStore}
      identifier="DEALS_PIPELINE_TABLE"
    >
      <FilterGroup title="Account">
        <SelectFilter
          filterStore={dealsPipelineFilterStore}
          filterKey="sales_stage"
          title="Sales Stage"
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          options={stageOptions as any}
        />
        <SelectFilter
          filterKey="account_owner"
          title="Account Owner"
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          options={userOptions as any}
          filterStore={dealsPipelineFilterStore}
        />
        <SelectFilter
          title="Product"
          filterStore={dealsPipelineFilterStore}
          filterKey="product"
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          options={products as any}
        />
        <RangeFilter
          store={dealsPipelineFilterStore}
          filterKey="count"
          title="Deals Count"
        />
        <RangeFilter
          store={dealsPipelineFilterStore}
          filterKey="closed"
          title="Closed Deals Count"
        />
        <RangeFilter
          store={dealsPipelineFilterStore}
          filterKey="taro"
          title="Annual Rev. Opp."
        />
        <RangeFilter
          store={dealsPipelineFilterStore}
          filterKey="taro_closed"
          title="Closed Annual Rev. Opp."
        />
        <DateRangeFilter
          title={'Last Update'}
          filterKey={'last_modified'}
          filterStore={dealsPipelineFilterStore}
        />
        <RangeFilter
          title={'Days Since Last Update'}
          filterKey={'days_since_last_modified'}
          store={dealsPipelineFilterStore}
        />
      </FilterGroup>
      <FilterGroup title={'Opportunity Details'}>
        <SelectFilter
          title="Category"
          filterKey={'category'}
          filterStore={dealsPipelineFilterStore}
          options={categoriesOptions}
        />
        <SelectFilter
          title="Type"
          filterKey={'sub_category'}
          filterStore={dealsPipelineFilterStore}
          options={subCategoriesOptions}
        />
      </FilterGroup>
    </FilterModal>
  )
}
